import { createTypes, createAction } from "lib/action";

const LOAD_PRODUCTTYPE = createTypes("producttype", "load");
const SHOW_PRODUCTTYPE = createTypes("producttype", "show");
const CREATE_PRODUCTTYPE = createTypes("producttype", "create");
const UPDATE_PRODUCTTYPE = createTypes("producttype", "update");
const DELETE_PRODUCTTYPE = createTypes("producttype", "delete");
const IMPORT_PRODUCTTYPE = createTypes("producttype", "import");
const EXPORT_PRODUCTTYPE = createTypes("producttype", "export");

const loadProductTypes = {
  request: (params, token) =>
    createAction(LOAD_PRODUCTTYPE.REQUEST, { params, token }),
  success: (data) => createAction(LOAD_PRODUCTTYPE.SUCCESS, { data }),
  failure: (err) => createAction(LOAD_PRODUCTTYPE.FAILURE, { err }),
};

const showProductType = {
  request: (id, token) => createAction(SHOW_PRODUCTTYPE.REQUEST, { id, token }),
  success: (data) => createAction(SHOW_PRODUCTTYPE.SUCCESS, { data }),
  failure: (err) => createAction(SHOW_PRODUCTTYPE.FAILURE, { err }),
};

const createProductType = {
  request: (params, token) =>
    createAction(CREATE_PRODUCTTYPE.REQUEST, { params, token }),
  success: (data) => createAction(CREATE_PRODUCTTYPE.SUCCESS, { data }),
  failure: (err) => createAction(CREATE_PRODUCTTYPE.FAILURE, { err }),
};

const updateProductType = {
  request: (params, id, token) =>
    createAction(UPDATE_PRODUCTTYPE.REQUEST, { params, id, token }),
  success: (data) => createAction(UPDATE_PRODUCTTYPE.SUCCESS, { data }),
  failure: (err) => createAction(UPDATE_PRODUCTTYPE.FAILURE, { err }),
};

const deleteProductType = {
  request: (id, token) =>
    createAction(DELETE_PRODUCTTYPE.REQUEST, { id, token }),
  success: (id) => createAction(DELETE_PRODUCTTYPE.SUCCESS, { id }),
  failure: (err) => createAction(DELETE_PRODUCTTYPE.FAILURE, { err }),
};

const importProductType = {
  request: (file, company_id, token) =>
    createAction(IMPORT_PRODUCTTYPE.REQUEST, { file, company_id, token }),
  success: (data) => createAction(IMPORT_PRODUCTTYPE.SUCCESS, { data }),
  failure: (err) => createAction(IMPORT_PRODUCTTYPE.FAILURE, { err }),
};

const exportProductType = {
  request: (token) => createAction(EXPORT_PRODUCTTYPE.REQUEST, { token }),
  success: (data) => createAction(EXPORT_PRODUCTTYPE.SUCCESS, { data }),
  failure: (err) => createAction(EXPORT_PRODUCTTYPE.FAILURE, { err }),
};

export {
  loadProductTypes,
  showProductType,
  createProductType,
  updateProductType,
  deleteProductType,
  importProductType,
  exportProductType,
  LOAD_PRODUCTTYPE,
  SHOW_PRODUCTTYPE,
  CREATE_PRODUCTTYPE,
  UPDATE_PRODUCTTYPE,
  DELETE_PRODUCTTYPE,
  IMPORT_PRODUCTTYPE,
  EXPORT_PRODUCTTYPE,
};
